var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUspPill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "lucide/pill",
    clipPath: "url(#clip0_0_318)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.2489 10.2562L10.2562 5.2489C10.4902 5.0196 10.6764 4.74619 10.8041 4.44448C10.9317 4.14277 10.9983 3.81875 11 3.49115C11.0016 3.16355 10.9383 2.83887 10.8137 2.53589C10.6891 2.2329 10.5057 1.95763 10.274 1.72597C10.0424 1.49432 9.7671 1.31089 9.46411 1.18629C9.16113 1.06168 8.83645 0.998377 8.50885 1.00003C8.18125 1.00169 7.85723 1.06827 7.55552 1.19593C7.25381 1.32358 6.9804 1.50979 6.7511 1.74377L1.74377 6.7511C1.50979 6.9804 1.32358 7.25381 1.19593 7.55552C1.06827 7.85723 1.00169 8.18125 1.00003 8.50885C0.998377 8.83645 1.06168 9.16113 1.18629 9.46411C1.31089 9.7671 1.49432 10.0424 1.72597 10.274C1.95763 10.5057 2.2329 10.6891 2.53589 10.8137C2.83887 10.9383 3.16355 11.0016 3.49115 11C3.81875 10.9983 4.14277 10.9317 4.44448 10.8041C4.74619 10.6764 5.0196 10.4902 5.2489 10.2562Z",
    stroke: "var(--stroke-0, white)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M4 4L8 8",
    stroke: "var(--stroke-0, white)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_318"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUspPill);
export default __webpack_public_path__ + "static/media/usp-pill.b93decb9a45872711f0273ebde3f477d.svg";
export { ForwardRef as ReactComponent };